import { Fragment } from "react";
import { classNames } from "@/utils";
import { CommunityOverview } from "@/models/community.model";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@/icons";
import { CommunityTab, handleCommunityDotColors } from "./utils";

interface Props {
  communities: CommunityOverview[];
  activeCommunity: CommunityOverview;
  setActiveCommunity: (tag: string) => void;
}

export default function Example(props: Props) {
  const { communities, activeCommunity, setActiveCommunity } = props;

  return (
    <div className="lg:hidden">
      <Listbox
        value={activeCommunity}
        onChange={(community) => setActiveCommunity(community.tag)}
      >
        {({ open }) => (
          <>
            <Listbox.Label className="block font-medium text-gray-500">
              Show community
            </Listbox.Label>
            <div className="relative mt-1">
              <Listbox.Button className="relative w-full cursor-default rounded-md border border-transparent bg-card py-4 pl-3 pr-10 text-left shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm">
                <div className="flex items-center">
                  <span
                    aria-label={activeCommunity.type}
                    className={`${handleCommunityDotColors(
                      activeCommunity.type as CommunityTab
                    )}
                      inline-block h-2 w-2 flex-shrink-0 rounded-full
                    `}
                  />
                  <span className="ml-3 block truncate">
                    {activeCommunity.name}
                  </span>
                </div>
                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                  <ChevronDownIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </span>
              </Listbox.Button>

              <Transition
                show={open}
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-navMobile py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                  {communities?.map((community, index) => (
                    <Listbox.Option
                      key={index}
                      className={({ active }) =>
                        classNames(
                          active
                            ? "bg-card__light text-white"
                            : "text-gray-400",
                          "relative cursor-default select-none py-3 pl-3 pr-9"
                        )
                      }
                      value={community}
                    >
                      {({ selected, active }) => (
                        <>
                          <div className="flex items-center">
                            <span
                              className={`${handleCommunityDotColors(
                                community.type as CommunityTab
                              )}
                                inline-block h-2 w-2 flex-shrink-0 rounded-full
                              `}
                              aria-hidden="true"
                            />
                            <span
                              className={classNames(
                                selected ? "font-semibold" : "font-normal",
                                "ml-3 block truncate"
                              )}
                            >
                              {community.name}
                              <span className="sr-only">
                                {" "}
                                is {community.type}
                              </span>
                            </span>
                          </div>

                          {selected ? (
                            <span
                              className={classNames(
                                active ? "text-white" : "text-slate-300",
                                "absolute inset-y-0 right-0 flex items-center pr-4"
                              )}
                            >
                              <CheckIcon
                                className="h-5 w-5"
                                aria-hidden="true"
                              />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </div>
          </>
        )}
      </Listbox>
    </div>
  );
}
